<textarea
  class="textarea"
  [attr.rows]="rows"
  [attr.tabindex]="tabindex"
  [class.textarea--error]="hasError"
  [disabled]="disabled"
  [attr.id]="id"
  [attr.aria-describedby]="errorsId"
  [attr.placeholder]="placeholder"
  [required]="required"
  [formControl]="textarea"
  (blur)="touched()"
></textarea>

<div *ngIf="hasCounter" class="character-counter">
  <span
    class="character-counter__value"
    [class.character-counter__value--has-error]="
      textarea?.touched && textarea?.invalid
    "
  >
    {{ currentCharactersCounter }} /
  </span>
  {{ minLength || maxLength }}
</div>
